(() => {
  function init(scope = document) {
    const sections = scope.matches?.('[data-s7-fold]')
      ? [scope]
      : [...(scope.querySelectorAll?.('[data-s7-fold]') || [])];

    sections.forEach(section => {
      if (section.dataset.foldInitialized === 'true') return;
      section.dataset.foldInitialized = 'true';

      const box = section.querySelector('[data-fold-compare]');
      const knob = section.querySelector('[data-fold-knob]');
      if (!box || !knob) return;

      let dragging = false;
      let position = 50;

      const apply = value => {
        position = Math.max(5, Math.min(95, value));
        box.style.setProperty('--fold-position', `${position}%`);
        knob.setAttribute('aria-valuenow', String(Math.round(position)));
      };

      const fromClientX = clientX => {
        const rect = box.getBoundingClientRect();
        if (!rect.width) return;
        const percent = ((clientX - rect.left) / rect.width) * 100;
        apply(percent);
      };

      box.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        box.setPointerCapture?.(event.pointerId);
        fromClientX(event.clientX);
      });

      box.addEventListener('pointermove', event => {
        if (!dragging) return;
        fromClientX(event.clientX);
      });

      const stop = event => {
        dragging = false;
        if (event?.pointerId !== undefined) {
          box.releasePointerCapture?.(event.pointerId);
        }
      };

      box.addEventListener('pointerup', stop);
      box.addEventListener('pointercancel', stop);

      knob.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          apply(position - 5);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          apply(position + 5);
        } else if (event.key === 'Home') {
          event.preventDefault();
          apply(5);
        } else if (event.key === 'End') {
          event.preventDefault();
          apply(95);
        }
      });

      apply(50);
    });
  }

  if (!window.__ISWS7FoldV2) {
    window.__ISWS7FoldV2 = { init };

    const boot = () => init(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('page:loaded', boot);

    document.addEventListener('shopify:section:load', event => {
      init(event.target);
    });
  } else {
    window.__ISWS7FoldV2.init(document);
  }
})();
